import styled from 'styled-components'

export const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  header {
    padding-top: 0;
  }
`

export const MainWrapper = styled.main`
  padding: 60px 0 0;
  flex: 1;

  @media (max-width: 768px) {
    padding: 0 0 0;
    margin-top: 48px;
  }
`

export const NewMainWrapper = styled.main`
`

export const OneWrapper = styled.main`
  padding: 0 0 0;
  flex: 1;

  @media (max-width: 768px) {
    padding: 0 0 0;
    margin-top: 56px;
  }
`

export const CleanMainWrapper = styled(MainWrapper)`
  margin-top: 0;
`

export const FormMultiStepMain = styled.main`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;

  @media (max-width: 767px) {
    justify-content: flex-start;
  }
`
